(function () {
  function dateParts(time) {
    var fmt = new Intl.DateTimeFormat('en-GB', {year:'numeric',month:'2-digit',day:'2-digit',timeZone:'Europe/Vilnius'});
    var parts = {};
    fmt.formatToParts(time).forEach(function (p) { parts[p.type]=p.value; });
    return [Number(parts.year),Number(parts.month),Number(parts.day)];
  }
  function calcDays(date, now) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return null;
    var t = date.split('-').map(Number);
    if (t[1]<1||t[1]>12||t[2]<1||t[2]>31) return null;
    var current = dateParts(now);
    return Math.round((Date.UTC(t[0],t[1]-1,t[2]) - Date.UTC(current[0],current[1]-1,current[2])) / 86400000);
  }
  function paint(root) {
    var days = calcDays(root.dataset.deadline || '',new Date());
    if(days === null) return;
    if(days < 0) {root.hidden = true;} else {root.hidden = false;}
    document.querySelectorAll('[data-mz-date-dependent]').forEach(function(el){el.hidden = days < 0;});
    if(days < 0) return;
    var n = root.querySelector('[data-mz-countdown-days]');
    var label = root.querySelector('[data-mz-countdown-label]');
    if (n) n.textContent=String(days);
    if (label) label.textContent=days===0 ? 'PASKUTINĖ DIENA PATEIKTI UŽKLAUSĄ' : 'DIENŲ PATEIKTI UŽKLAUSĄ';
  }
  function init() {document.querySelectorAll('[data-mz-holiday]').forEach(paint);}
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
  if (!window.__mzHolidayTicker) {window.__mzHolidayTicker=setInterval(init,60*60*1000);}
})();
